import { Facebook, Instagram, MessageCircle, Mail } from "lucide-react";
import { COMPANY, buildWhatsAppLink } from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#070F25] text-white border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand mini */}
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="San José Shipping" className="h-10 w-10 object-contain bg-white p-0.5 rounded" />
            <div className="text-xs text-white/70 leading-tight">
              <div className="font-display font-black uppercase tracking-wider text-white text-sm">San José Shipping LLC</div>
              <div className="italic text-[10px]">Tu compañía de confianza</div>
            </div>
          </div>

          {/* Copyright + email */}
          <div className="text-xs text-white/60 text-center flex flex-col items-center gap-1">
            <a
              data-testid="footer-email"
              href={`mailto:${COMPANY.email}`}
              className="inline-flex items-center gap-1.5 text-white hover:text-[#D61F26] transition-colors font-semibold"
            >
              <Mail className="w-3.5 h-3.5" />
              {COMPANY.email}
            </a>
            <span>© {year} San José Shipping LLC. Todos los derechos reservados.</span>
          </div>

          {/* Socials */}
          <div className="flex items-center gap-2">
            <a
              data-testid="footer-facebook"
              href={COMPANY.facebook}
              target="_blank" rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 rounded-full flex items-center justify-center bg-white/5 hover:bg-[#D61F26] transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              data-testid="footer-instagram"
              href={COMPANY.instagram}
              target="_blank" rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 rounded-full flex items-center justify-center bg-white/5 hover:bg-[#D61F26] transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              data-testid="footer-whatsapp"
              href={buildWhatsAppLink()}
              target="_blank" rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 rounded-full flex items-center justify-center bg-white/5 hover:bg-[#25D366] transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
